import axios from "axios";

export const GET_PROD_STATS = "GET_PROD_STATS";

export const getProdStats = () => async (dispatch) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/prodstats`,
      { withCredentials: true }
    );
    dispatch({ type: GET_PROD_STATS, payload: res.data });
  } catch (error) {
    console.error(error);
  }
};

// Enregistre l'ensemble des chiffres (réservé aux admins côté serveur).
// Renvoie la liste fraîchement persistée.
export const saveProdStats = (stats) => async (dispatch) => {
  const res = await axios({
    method: "put",
    url: `${process.env.REACT_APP_API_URL}/api/prodstats`,
    withCredentials: true,
    data: { stats },
  });
  dispatch({ type: GET_PROD_STATS, payload: res.data });
  return res.data;
};
